<template>
  <fin-avatar :avatar-image-style="avatarImageStyle"
              :disable-tooltip="disableTooltip"
              :item="item"/>
</template>

<script>
import FinAvatar from "@/components/common/avatar"

export default {
  name: "finArchetypeAvatar",
  components: {FinAvatar},
  props: {
    /** The id of the archetype to display */
    archetypeId: {
      type: String,
      required: true
    },
    /** The tooltip text to show on hover */
    tooltip: {
      type: String
    },
    /** Disables the tooltip, just showing the avatar */
    disableTooltip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      avatarImageStyle: 'top: 17px; transform: scale(1.7);',
    }
  },
  computed: {
    item() {
      return {
        img: require('@/assets/archetypes/' + this.archetypeId.toLocaleLowerCase() + '.svg'),
        title: this.tooltip,
      }
    }
  }
}
</script>

<style scoped>

</style>
